var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 19,
    transform: "matrix(-1 0 0 1 19.5 19)",
    fill: "#3388FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0303 20.5303C28.3232 20.2374 28.3232 19.7626 28.0303 19.4697L23.2574 14.6967C22.9645 14.4038 22.4896 14.4038 22.1967 14.6967C21.9038 14.9896 21.9038 15.4645 22.1967 15.7574L26.4393 20L22.1967 24.2426C21.9038 24.5355 21.9038 25.0104 22.1967 25.3033C22.4896 25.5962 22.9645 25.5962 23.2574 25.3033L28.0303 20.5303ZM11.5 20.75H27.5V19.25H11.5V20.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/nextButton.7fcfd778a045ade33ebba0ebeb7422d7.svg";
export { ForwardRef as ReactComponent };